import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useEffect, useState } from 'react';

import { settingscolumns } from './settingscolumns';
import { API, graphqlOperation } from 'aws-amplify';
import { listGeneralSetting, listUserPreference } from '../../../graphql';
import GeneralSettings from '../../../components/modals/general-setting';
import Setting from './setting';
import { useSelector } from 'react-redux';
import { defaultSettings } from '../../../utils/Data/StaticData';
import { listGeneralSettingV2 } from '../../../graphql';
import { useLocation } from 'react-router-dom';
import { useThemes } from '../../../components/Theme/theme';

const NewGeneralSetting = ({ fyData, topm, expanded }) => {
  const [listGoods, setListGoods] = useState([]);
  const [listService, setListService] = useState([]);
  const [listInvoice, setListInvoice] = useState([]);
  const [listPurchase, setListPurchase] = useState([]);
  const [listPos, setListPos] = useState([]);
  const [listPayment, setListPayment] = useState([]);
  const [listJournal, setListJournal] = useState([]);
  const [listReceipt, setListReceipt] = useState([]);
  const [listCredit, setListCredit] = useState([]);
  const [listDebit, setListDebit] = useState([]);
  const [modal, setModal] = useState('');
  const [editId, setEditID] = useState(null);
  const [setting, setSettings] = useState(defaultSettings);
  const [Open, setOpen] = useState(false);

  const [goodsMode, setGoodsMode] = useState('AUTO');
  const [serviceMode, setServiceMode] = useState('AUTO');
  const [salesMode, setSalesMode] = useState('AUTO');
  const [purchaseMode, setPurchaseMode] = useState('AUTO');
  const [posMode, setPOSMode] = useState('AUTO');
  const [journalMode, setJournalMode] = useState('AUTO');
  const [paymentMode, setPaymentMode] = useState('AUTO');
  const [receiptMode, setreceiptMode] = useState('AUTO');
  const [debitMode, setDebitMode] = useState('AUTO');
  const [creditMode, setCreditMode] = useState('AUTO');
  const [fyid, setFyid] = useState(fyData?.financialyearid);
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  const regType = getCompany.relatedcompanydetailsnew[0].registrationtype;
  const unRegCompBool = regType == 1 || regType == 3;
  const handleSettings = (setting) => {
    setOpen(true);
    setModal(setting);
    if (unRegCompBool === true) {
      setSettings({
        ...setting,
        taxability: 3,
      });
    } else {
      setSettings(defaultSettings);
    }
  };
  const location = useLocation();
  console.log(location, 'location');
  const newFyId = useSelector((state) => state?.newFyStepsReducer?.newFYDta);
  const { theme } = useThemes();

  async function getCurrentFinancialYearDetailsFn(cb) {
    try {
      if (fyData?.financialyearid) {
        cb(fyData?.financialyearid);
      } else {
        const graphqlUSerRes = await API.graphql(graphqlOperation(listUserPreference));
        let FYID = graphqlUSerRes?.data?.listUserPreference?.find((item) => item?.attributetypecd === 'SelectedFinYear');
        setFyid(FYID.attributevalue);
        cb(FYID.attributevalue);
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    if (expanded || location.pathname === '/defaultformats') {
      getCurrentFinancialYearDetailsFn(getSettings);
    }
  }, [expanded]);
  async function getSettings(id) {
    try {
      const res2 = await API.graphql(
        graphqlOperation(listGeneralSettingV2, {
          EntryTypeCD1: 'Item',
          EntryTypeCD2: 'Service',
          EntryTypeCD3: 'SalesInvoice',
          EntryTypeCD4: 'PurchaseInvoice',
          EntryTypeCD5: 'PosInvoice',
          EntryTypeCD6: 'Journal',
          EntryTypeCD7: 'Payment',
          EntryTypeCD8: 'Receipt',
          EntryTypeCD9: 'CreditInvoice',
          EntryTypeCD10: 'DebitInvoice',
          FinancialYearID: id,
        })
      );
      setListGoods(res2.data.goods.filter((ar) => ar.nextinvoicenumber !== -1));
      setListService(res2.data.service.filter((ar) => ar.nextinvoicenumber !== -1));
      setListInvoice(res2.data.sales.filter((ar) => ar.nextinvoicenumber !== -1));
      setListPurchase(res2.data.purchase.filter((ar) => ar.nextinvoicenumber !== -1));
      setListPos(res2.data.pos.filter((ar) => ar.nextinvoicenumber !== -1));
      setListPayment(res2.data.payment.filter((ar) => ar.nextinvoicenumber !== -1));
      setListJournal(res2.data.journal.filter((ar) => ar.nextinvoicenumber !== -1));
      setListReceipt(res2.data.receipt.filter((ar) => ar.nextinvoicenumber !== -1));
      setListCredit(res2.data.credit.filter((ar) => ar.nextinvoicenumber !== -1));
      setListDebit(res2.data.debit.filter((ar) => ar.nextinvoicenumber !== -1));
      const modeCheck = (data, setData) => {
        const check = data.filter((ar) => ar.nextinvoicenumber === -1 && ar.expiredtimestamp === 0);
        if (check && check?.length > 0) {
          setData('MANUAL');
        }
      };
      modeCheck(res2.data.goods, setGoodsMode);
      modeCheck(res2.data.service, setServiceMode);
      modeCheck(res2.data.sales, setSalesMode);
      modeCheck(res2.data.purchase, setPurchaseMode);
      modeCheck(res2.data.pos, setPOSMode);
      modeCheck(res2.data.payment, setPaymentMode);
      modeCheck(res2.data.journal, setJournalMode);
      modeCheck(res2.data.receipt, setreceiptMode);
      modeCheck(res2.data.credit, setCreditMode);
      modeCheck(res2.data.debit, setDebitMode);
    } catch (error) {
      console.log('error', error);
    }
  }
  async function getSingleSettings(setting, method, id) {
    try {
      const res2 = await API.graphql(
        graphqlOperation(listGeneralSetting, {
          entrytypecd: setting,
          financialyearid: id,
        })
      );
      const manualMode = res2.data.listGeneralSetting.filter((ar) => ar.nextinvoicenumber === -1 && ar.expiredtimestamp === 0);

      if (manualMode && manualMode.length > 0) {
        switch (setting) {
          case 'Item':
            setGoodsMode('MANUAL');
            break;

          case 'Service':
            setServiceMode('MANUAL');
            break;

          case 'SalesInvoice':
            setSalesMode('MANUAL');
            break;

          case 'PurchaseInvoice':
            setPurchaseMode('MANUAL');
            break;

          case 'PosInvoice':
            setPOSMode('MANUAL');
            break;

          case 'Payment':
            setPaymentMode('MANUAL');
            break;

          case 'Journal':
            setJournalMode('MANUAL');
            break;

          case 'Receipt':
            setreceiptMode('MANUAL');
            break;

          case 'CreditInvoice':
            setCreditMode('MANUAL');
            break;

          case 'DebitInvoice':
            setDebitMode('MANUAL');
            break;

          default:
            setGoodsMode('AUTO');
            setServiceMode('AUTO');
            setSalesMode('AUTO');
            setPurchaseMode('AUTO');
            setPOSMode('AUTO');
            setPaymentMode('AUTO');
            setJournalMode('AUTO');
            setreceiptMode('AUTO');
            setCreditMode('AUTO');
            setDebitMode('AUTO');
        }
      }

      const filteredArr = res2.data.listGeneralSetting.filter((ar) => ar.nextinvoicenumber !== -1);
      const sortedArr = filteredArr.sort((a, b) => b.applicablefrom - a.applicablefrom);

      method(sortedArr);
    } catch (error) {
      console.log('error', error);
    }
  }

  function findObjectByField(field, value, ...arrays) {
    const foundObjects = arrays.map((array) => array.find((object) => object[field] === value));
    return foundObjects.filter((object) => object !== undefined);
  }
  useEffect(() => {
    setEditID('');
  }, []);

  useEffect(() => {
    if (editId?.id) {
      const objects = findObjectByField(
        'id',
        editId?.id,
        listGoods,
        listService,
        listInvoice,
        listPurchase,
        listPos,
        listPayment,
        listJournal,
        listReceipt,
        listCredit,
        listDebit
      );
      setOpen(true);
      setModal(objects[0]?.entrytypecd);
      setSettings(objects[0]);
    }
  }, [editId?.id]);

  const yearId = fyData?.financialyearid ? fyData?.financialyearid : fyid;
  useEffect(() => {
    if (Open == false) {
      modal === 'Item'
        ? getSingleSettings('Item', setListGoods, yearId)
        : modal === 'Service'
        ? getSingleSettings('Service', setListService, yearId)
        : modal === 'SalesInvoice'
        ? getSingleSettings('SalesInvoice', setListInvoice, yearId)
        : modal === 'PurchaseInvoice'
        ? getSingleSettings('PurchaseInvoice', setListPurchase, yearId)
        : modal === 'PosInvoice'
        ? getSingleSettings('PosInvoice', setListPos, yearId)
        : modal === 'Journal'
        ? getSingleSettings('Journal', setListJournal, yearId)
        : modal === 'Payment'
        ? getSingleSettings('Payment', setListPayment, yearId)
        : modal === 'Receipt'
        ? getSingleSettings('Receipt', setListReceipt, yearId)
        : modal === 'CreditInvoice'
        ? getSingleSettings('CreditInvoice', setListCredit, yearId)
        : modal === 'DebitInvoice'
        ? getSingleSettings('DebitInvoice', setListDebit, yearId)
        : console.log('jj', modal);
    }
  }, [modal, Open]);

  const GoodsList = goodsMode === 'MANUAL' ? listGoods.slice(0, 1) : listGoods;
  const ServiceList = serviceMode === 'MANUAL' ? listService.slice(0, 1) : listService;
  const SalesList = salesMode === 'MANUAL' ? listInvoice.slice(0, 1) : listInvoice;
  const PurchaseList = purchaseMode === 'MANUAL' ? listPurchase.slice(0, 1) : listPurchase;
  const POSList = posMode === 'MANUAL' ? listPos.slice(0, 1) : listPos;
  const JournalList = journalMode === 'MANUAL' ? listJournal.slice(0, 1) : listJournal;
  const PaymentList = paymentMode === 'MANUAL' ? listPayment.slice(0, 1) : listPayment;
  const ReceiptList = receiptMode === 'MANUAL' ? listReceipt.slice(0, 1) : listReceipt;
  const DebitList = debitMode === 'MANUAL' ? listDebit.slice(0, 1) : listDebit;
  const CreditList = creditMode === 'MANUAL' ? listCredit.slice(0, 1) : listCredit;
  const handleDelete = (itemId, items, setItems) => {
    setItems(items.filter((item) => item?.id !== itemId));
  };
  console.log(listGoods, 'listGoods');

  return (
    <Box
      sx={{
        height: { lg: '100%' },
        overflow: { lg: 'hidden' },
      }}
    >
      <Grid container>
        <GeneralSettings
          label={modal}
          open={Open}
          editId={editId}
          setEditID={setEditID}
          setOpen={setOpen}
          setId={fyid}
          item={setting}
          setItem={setSettings}
          setting={setting}
          listItems={
            modal === 'Item'
              ? listGoods
              : modal === 'Service'
              ? listService
              : modal === 'SalesInvoice'
              ? listInvoice
              : modal === 'PurchaseInvoice'
              ? listPurchase
              : modal === 'PosInvoice'
              ? listPos
              : modal === 'Journal'
              ? listJournal
              : modal === 'Payment'
              ? listPayment
              : modal === 'Receipt'
              ? listReceipt
              : modal === 'CreditInvoice'
              ? listCredit
              : modal === 'DebitInvoice'
              ? listDebit
              : []
          }
          setListItems={
            modal === 'Item'
              ? setListGoods
              : modal === 'Service'
              ? setListService
              : modal === 'SalesInvoice'
              ? setListInvoice
              : modal === 'PurchaseInvoice'
              ? setListPurchase
              : modal === 'PosInvoice'
              ? setListPos
              : modal === 'Journal'
              ? setListJournal
              : modal === 'Payment'
              ? setListPayment
              : modal === 'Receipt'
              ? setListReceipt
              : modal === 'CreditInvoice'
              ? setListCredit
              : modal === 'DebitInvoice'
              ? setListDebit
              : null
          }
        />
        <Grid item xs={12} sx={{ padding: { sm: '10px', xs: '5px' } }}>
          <TableContainer
            sx={
              topm
                ? {
                    height: {
                      sm: 'calc( 100vh - 150px )',
                      xs: 'calc( 100vh - 130px )',
                    },
                  }
                : { height: '500px' }
            }
          >
            <Table
              stickyHeader
              aria-label="simple table"
              aria-labelledby="tableTitle"
              sx={{
                '.MuiTableCell-root': { padding: '5px!important', backgroundColor: 'primary.main' },
              }}
            >
              <TableHead>
                <TableRow className="noTableCellBorder">
                  {settingscolumns.map((column) => (
                    <TableCell
                      align="left"
                      key={column.id}
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        fontWeight: 'bold',
                        // minWidth: column.maxWidth,
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'white',
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody
                sx={{
                  '.MuiTableCell-root': {
                    backgroundColor: 'transparent !important',
                  },
                }}
              >
                {[...GoodsList]

                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      list={listGoods}
                      setItem={setListGoods}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      onDelete={() => handleDelete(dat.id, listGoods, setListGoods)}
                      item={dat}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      mode={goodsMode}
                      setMode={setGoodsMode}
                      index={i}
                      setEditID={setEditID}
                      editId={editId}
                      title=" Item Code (Goods)"
                      length={listGoods.length}
                      method={handleSettings}
                      modal="Item"
                    />
                  ))}
                {[...ServiceList]

                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      list={listService}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      onDelete={() => handleDelete(dat.id, listService, setListService)}
                      setItem={setListService}
                      item={dat}
                      setId={fyid}
                      mode={serviceMode}
                      setMode={setServiceMode}
                      index={i}
                      setEditID={setEditID}
                      editId={editId}
                      title=" Item Code (Service)"
                      length={listService.length}
                      method={handleSettings}
                      modal="Service"
                    />
                  ))}
                {[...SalesList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      item={dat}
                      mode={salesMode}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyid}
                      setMode={setSalesMode}
                      list={listInvoice}
                      onDelete={() => handleDelete(dat.id, listInvoice, setListInvoice)}
                      setItem={setListInvoice}
                      index={i}
                      setEditID={setEditID}
                      editId={editId}
                      title="Sales invoice number"
                      length={listInvoice.length}
                      method={handleSettings}
                      modal="SalesInvoice"
                    />
                  ))}
                {[...PurchaseList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      item={dat}
                      list={listPurchase}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      onDelete={() => handleDelete(dat.id, listPurchase, setListPurchase)}
                      setItem={setListPurchase}
                      mode={purchaseMode}
                      setMode={setPurchaseMode}
                      index={i}
                      setEditID={setEditID}
                      editId={editId}
                      title="Purchase invoice number"
                      length={listPurchase.length}
                      method={handleSettings}
                      modal="PurchaseInvoice"
                    />
                  ))}
                {[...POSList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      item={dat}
                      list={listPos}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      onDelete={() => handleDelete(dat.id, listPos, setListPos)}
                      setItem={setListPos}
                      index={i}
                      mode={posMode}
                      setMode={setPOSMode}
                      setEditID={setEditID}
                      editId={editId}
                      title="POS invoice Number"
                      length={listPos.length}
                      method={handleSettings}
                      modal="PosInvoice"
                    />
                  ))}
                {[...JournalList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      item={dat}
                      list={listJournal}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      onDelete={() => handleDelete(dat.id, listJournal, setListJournal)}
                      setItem={setListJournal}
                      index={i}
                      mode={journalMode}
                      setMode={setJournalMode}
                      setEditID={setEditID}
                      editId={editId}
                      title="Journal Voucher number"
                      length={listJournal.length}
                      method={handleSettings}
                      modal="Journal"
                    />
                  ))}
                {[...PaymentList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      item={dat}
                      list={listPayment}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      onDelete={() => handleDelete(dat.ID, listPayment, setListPayment)}
                      setItem={setListPayment}
                      index={i}
                      mode={paymentMode}
                      setMode={setPaymentMode}
                      setEditID={setEditID}
                      editId={editId}
                      title="Payment Voucher number"
                      length={listPayment.length}
                      method={handleSettings}
                      modal="Payment"
                    />
                  ))}
                {[...ReceiptList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.ID}
                      item={dat}
                      list={listReceipt}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      onDelete={() => handleDelete(dat.id, listReceipt, setListReceipt)}
                      setItem={setListReceipt}
                      index={i}
                      mode={receiptMode}
                      setMode={setreceiptMode}
                      setEditID={setEditID}
                      editId={editId}
                      title="Receipt Voucher number"
                      length={listReceipt.length}
                      method={handleSettings}
                      modal="Receipt"
                    />
                  ))}
                {[...CreditList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      item={dat}
                      list={listCredit}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      onDelete={() => handleDelete(dat.id, listCredit, setListCredit)}
                      setItem={setListCredit}
                      index={i}
                      mode={creditMode}
                      setMode={setCreditMode}
                      setEditID={setEditID}
                      editId={editId}
                      title="Credit Note number"
                      length={listCredit.length}
                      method={handleSettings}
                      modal="CreditInvoice"
                    />
                  ))}

                {[...DebitList]
                  .sort((a, b) => a.id - b.id)
                  .map((dat, i) => (
                    <Setting
                      key={dat.id}
                      item={dat}
                      list={listDebit}
                      yearId={yearId}
                      setSingle={getSingleSettings}
                      setId={fyData?.financialyearid ? fyData?.financialyearid : fyid}
                      onDelete={() => handleDelete(dat.id, listDebit, setListDebit)}
                      setItem={setListDebit}
                      index={i}
                      mode={debitMode}
                      setMode={setDebitMode}
                      setEditID={setEditID}
                      editId={editId}
                      title="Debit Note number"
                      length={listDebit.length}
                      method={handleSettings}
                      modal="DebitInvoice"
                    />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NewGeneralSetting;
